
export const myAction=(data,dispatch)=>{


    dispatch({

        type:"Authentication",
        Payload:data

    })

}
export const myAction1=(data,dispatch)=>{


    dispatch({

        type:"AuthenticationData",
        Payload:data

    })

}